<template>
  <section class="section-table">
    <div class="my-3 d-flex justify-content-between align-items-center">
        <h3 class="mb-0">Referrer User Management</h3>
        <el-button size="small" type="success" @click="openUserModal(false)">Create</el-button>
    </div>
    <el-table
        :data="users"
        @expand-change="loadAffiliateLinks"
        style="width: 100%">
        <el-table-column type="expand">
        <template slot-scope="props">
            <div class="section-table">
                <div class="my-3 d-flex justify-content-between align-items-center">
                    <el-divider content-position="left">Referrer affiliate link management</el-divider>
                    <el-button size="small" type="success" @click="generateAffiliateLink(props.row)">Generate Link</el-button>
                </div>

                <el-table
                    :data="_.get(props, 'row.affiliateLinks')"
                    v-loading="tableLoading"
                    stripe
                    border
                    style="width: 100%"
                    >
                    <el-table-column width="500" sortable label="Link">
                        <template slot-scope="affiliateScope">
                            <a :href="_.toLower(_.get(affiliateScope, 'row.link.default_short_url'))" :target="'_blank'">{{ _.toLower(_.get(affiliateScope, 'row.link.default_short_url')) }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column  v-if="Ambition.teamsEnabled()" width="250" sortable label="Team">
                        <template slot-scope="affiliateScope">
                            <el-select v-model="affiliateScope.row.team_id" placeholder="Default Team" clearable filterable @change="assignToAffiliate($event, affiliateScope.row, 'team')" >
                                <el-option
                                    v-for="team in teams"
                                    :key="team.id"
                                    :label="team.name"
                                    :value="`${team.id}`">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column width="250" sortable label="Form">
                        <template slot-scope="affiliateScope">
                            <el-select v-model="affiliateScope.row.form_id" filterable placeholder="Select Form" @change="assignToAffiliate($event, affiliateScope.row, 'form')">
                                <el-option
                                v-for="form in forms"
                                :key="form.id"
                                :label="form.name"
                                :value="`${form.id}`">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" sortable label="Visits">
                        <template slot-scope="affiliateScope">
                            <span>{{ _.size(_.get(affiliateScope,'row.link.visits', [])) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center" label="Embed Code">
                        <template slot-scope="affiliateScope">
                            <code>{{ _.get(affiliateScope,'row.embed_code') }}</code>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="QR Code">
                        <template slot-scope="affiliateScope">
                            <div style="max-width:50px; margin: 0 auto;"><qr-code :size="150" :text="_.get(affiliateScope, 'row.link.default_short_url')"></qr-code></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action" width="150" fixed="right" align="center">
                        <template slot-scope="affiliateScope">
                            <el-dropdown class="w-100">
                                <el-button :style="[_.get(affiliateScope, 'row.deleted_at') ? {'background-color': 'orange', 'color': 'white'} : {'color' : 'green'}]" size="small" @click="handleActionButtonClick">
                                    Action
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown" @change="loadAffiliateLinks">
                                    <el-dropdown-item v-if="!_.get(affiliateScope, 'row.deleted_at')" @click.native="disableAffiliateLink(props.row, affiliateScope.row)">
                                        <span>Disable Link</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="_.get(affiliateScope, 'row.deleted_at')" @click.native="enableAffiliateLink(props.row, affiliateScope.row)">
                                        <span>Enable Link</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="_.get(affiliateScope, 'row.deleted_at')" @click.native="deleteAffiliateLink(props.row, affiliateScope.row)">
                                        <span>Delete Link</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
        </el-table-column>
        <el-table-column
            width="200"
            label="Name"
            prop="full_name">
        </el-table-column>
        <el-table-column
            label="Referrer ID"
            width="150"
            align="center"
            prop="id">
        </el-table-column>
        <el-table-column
            label="Email"
            prop="email">
        </el-table-column>
        <el-table-column
            label="Phone"
            width="150"
            prop="phone">
        </el-table-column>
        <el-table-column label="Action" width="150" fixed="right" align="center">
            <template slot-scope="scope">
                <el-dropdown class="w-100">
                    <el-button style="color: green" size="small" @click="handleActionButtonClick">
                        Action
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="!scope.row.deleted_at"
                            @click.native="loginAs(scope.row)">
                            <span>Login as {{ scope.row.first_name }}</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!scope.row.deleted_at" @click.native="generateAffiliateLink(scope.row)">
                            <span>Generate Affiliate Link</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!scope.row.deleted_at"
                                            @click.native="sendPasswordRestLink(scope.row)">
                            <span>Send Password Reset</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!scope.row.deleted_at" @click.native="openUserModal(scope.row)">
                            <span>Edit</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!scope.row.deleted_at" @click.native="reset2FA(scope.row)">
                            <span>Reset 2FA</span>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.active" @click.native="deactivateUser(scope.row)">
                            <span>Suspend Account</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </el-table-column>
    </el-table>
    <x-modal
        :wWidth="1080"
        v-if="visible"
        @cancel="visible = false"
        @close="visible = false"
        @ok="saveUser()"
        :draggable="true"
        :resizable="true"
        :loading="loading"
        :okDisabled="loading"
        okText="Save"
    >
        <div slot="title" :class="`d-flex justify-content-between align-items-center`">
            {{ this.create ? "Create" : "Update" }} Referrer User
        </div>

        <el-form ref="userForm" :model="userForm" :rules="userFormRules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="First Name" prop="first_name">
                        <el-input v-model="userForm.first_name" placeholder="First Name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Last Name" prop="last_name">
                        <el-input v-model="userForm.last_name" placeholder="Last Name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Email Address" prop="email">
                        <el-input type="email" v-model="userForm.email" placeholder="Email Address"></el-input>
                    </el-form-item>
                    <el-alert v-if="!_.isEmpty(checkEmailExists)" :description="checkEmailExists"
                                type="error"></el-alert>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Phone Number" prop="phone">
                        <el-input v-model="userForm.phone" placeholder="Phone Number"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Timezone" prop="timezone">
                        <el-select class="w-100" filterable clearable v-model="userForm.timezone"
                                    placeholder="Timezone">
                            <el-option
                                v-for="timezone in timezones"
                                :key="timezone"
                                :label="timezone"
                                :value="timezone"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="create" :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Password" prop="password">
                        <el-input
                            type="password"
                            v-model="userForm.password"
                            placeholder="Password - if not set, user will need to reset password"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </x-modal>
  </section>
</template>

<script>
import Pagination from "@shared/components/pagination"
import VueQRCodeComponent from 'vue-qrcode-component'
import { computed } from "vue"
import { mapGetters } from "vuex"
import { ulid } from "ulid";
export default {
  name: 'referrerTable',
  components: {
    'qr-code':VueQRCodeComponent,
    Pagination
  },
  props: {
    referrerId: {
        required: true
    },
    users: {
        type: Array,
        required: true
    },
    teams: {
        type: Array,
    },
    timezones: {
        type: Array,
        required: true
    },
  },
  data() {
    return {
        create: false,
        userForm: {},
        userFormRules: {
            first_name: [{required: true, message: "First Name is Required", trigger: "change"}],
            last_name: [{required: true, message: "Last Name is Required", trigger: "change"}],
            email: [{required: true, message: "Email is Required", trigger: "change"}],
            phone: [{required: true, message: "Phone is Required", trigger: "change"}],
            timezone: [{required: true, message: "Timezone is Required", trigger: "change"}]
        },
        visible: false,
        loading: false,
        checkEmailExists: null,
        forms: [],
        tableLoading: true,
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.getForms();
  },
  updated() {
  },
  activated() {
  },
  methods: {
    handleActionButtonClick(e) {
        e.stopPropagation()
    },
    getForms() {
        this.$tenant
            .post(`/api/forms/list`)
            .then((res) => {
                this.forms = res.data
            })
            .catch((err) => {
                console.error(err)
            })
    },
    openUserModal(row) {
        this.create = true
        this.userForm = {}
        if (row) {
            this.create = false
            this.userForm = Object.assign({}, row)
        }
        setTimeout(() => {
            this.$refs["userForm"].clearValidate()
        }, 1)
        this.visible = true
        this.loading = false
    },
    saveUser() {
        this.$refs["userForm"].validate((valid) => {
            if (valid) {
                this.loading = true
                if (this.create && typeof this.userForm.password == "undefined") {
                    this.userForm.password = ulid()
                }
                if (this.create) {
                    this.$tenant
                    .post(`/admin/referrers/${this.referrerId}/user`, this.userForm)
                    .then((res) => {
                        this.loading = false
                        this.visible = false
                        this.users.push(res.data)
                    })
                    .catch((err) => {
                        console.error(err)
                    })
                } else if (this.userForm.id) {
                    this.$tenant
                    .put(`/admin/referrers/${this.referrerId}/user/${this.userForm.id}`, this.userForm)
                    .then((res) => {
                        this.loading = false
                        this.visible = false
                        this.users = this.users.map((user) =>
                            user.id == res.data.id ? {...user, ...res.data} : user
                        )
                    })
                    .catch((err) => {
                        console.error(err)
                    })
                }
            }
        })
    },

    loadAffiliateLinks(row, expanded, resetPage, scope) {
        this.tableLoading = true
        row.affiliateLinks = []

        if (resetPage) {
            this.users.current_page = 1
        }

        let data = {
            userId: row.id,
            paginated: false,
            referrer: true
        }

        this.$tenant
            .post(`/admin/account/get-affiliate-link`, data)
            .then((res) => {
                row.affiliateLinks.push(...res.data?.data);
                this.tableLoading = false
            })
            .catch((err) => {
                console.warn(err)
            })

    },
    rowHasRoles(row, roles = []) {
        return row.roles.find((e) => roles.includes(e.name)) !== undefined
    },
    reset2FA(row) {
        this.$admin
            .post(`/api/user-management/${Ambition.tenantId()}/reset-2fa`, row)
            .then((res) => {
                swal({
                    title: "Success!",
                    text: `You have successfully reset the Two Factor Authentication`,
                    type: "success",
                    showCancelButton: false,
                })
            })
            .catch((err) => {
                console.error(err)
            })
    },
    deactivateUser(row) {
        this.$admin
            .get(`/admin/auth/user/${row.id}/mark/0`)
            .then((res) => {
                swal({
                    title: "Disabled!",
                    text: `You have successfully disabled the referrer user`,
                    type: "success",
                    showCancelButton: false,
                })
            })
            .catch((err) => {
                console.error(err)
            })
    },
    loginAs(row) {
        const tenantUserId = row.id

        try {
            const loginUrl = `/admin/auth/user/${tenantUserId}/login-as`
            window.open(loginUrl)
        } catch (error) {
            this.$notify({type: "error", message: "Error attempting to login to referrer"})
            console.error("loginAs", {row})
        }
    },
    sendPasswordRestLink(row) {
        const tenantId = Ambition.tenantId()

        this.$admin
            .post(`/api/send-password-reset/${tenantId}`, {email: row.email})
            .then((res) => {
                swal({
                    title: "Success!",
                    text: `You have successfully sent password reset to ${_.get(row, "full_name")}`,
                    type: "success",
                    showCancelButton: false,
                })
            })
            .catch((error) => {
            })
    },
    assignToAffiliate(value, form, type) {
        let data;

        if (type == 'form'){
            data = {
                form_id: value
            };
        } else {
            data = {
                team_id: value
            };
        }


        this.$tenant
            .post(`/api/forms/assign-link/${form.id}`, data)
            .then((res) => {

            })
            .catch((err) => {
                console.error(err)
            })
    },
    generateAffiliateLink(row) {
        let links = _.size(row?.affiliateLinks) ? row.affiliateLinks : row.affiliateLinks = []
        this.$tenant
        .get(`/admin/auth/user/${row.id}/affiliate/create`)
        .then((res) => {
                links.push(res.data);
                this.users.doLayout()
            })
            .catch((err) => {
                console.error(err)
            })
    },
    disableAffiliateLink(user, link){
        this.$tenant
        .post(`/admin/auth/user/${user.id}/affiliate/${link.id}/disable`)
        .then((res) => {
                this.loadAffiliateLinks(user, true);
                this.$notify({
                    title: 'Success',
                    message: 'Link has been disabled',
                    type: 'success'
                });
            })
            .catch((err) => {
                console.error(err)
                this.$notify.error({
                    title: 'Error',
                    message: 'An error has occurred, try again.',
                });
            })
    },
    enableAffiliateLink(user, link){
        this.$tenant
        .post(`/admin/auth/user/${user.id}/affiliate/${link.id}/enable`)
        .then((res) => {
                this.loadAffiliateLinks(user, true);
                this.$notify({
                    title: 'Success',
                    message: 'Link has been enabled',
                    type: 'success'
                });
            })
            .catch((err) => {
                console.error(err)
                this.$notify.error({
                    title: 'Error',
                    message: 'An error has occurred, try again.',
                });
            })
    },
    deleteAffiliateLink(user, link){
        this.$tenant
        .delete(`/admin/auth/user/${user.id}/affiliate/${link.id}/delete`)
        .then((res) => {
                this.loadAffiliateLinks(user, true);
                this.$notify({
                    title: 'Success',
                    message: 'Links has been deleted',
                    type: 'success'
                });
            })
            .catch((err) => {
                console.error(err)
                this.$notify.error({
                    title: 'Error',
                    message: 'An error has occurred, try again.',
                });
            })
    }
  }
}
</script>

<style lang="scss" scoped>
.section-table {
    background-color: #f0f3f5;
    border: 1px solid #c2cfd6;
    padding: 10px;
    margin-bottom:5rem;

    .pagination-container {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px !important;

        &.pagination-top {
            margin-bottom: 10px !important;
        }

        &.pagination-bottom {
            margin-top: 10px !important;
            margin-bottom: 0 !important;
        }

        .el-pager {
            li {
                background-color: transparent;
                border: 1px solid #dcdfe6;
                font-weight: 400;

                &.active {
                    background-color: #69c23a;
                    border: none;
                }
            }
        }
    }

    .el-table {
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .el-table__row {
            cursor: pointer;

            &.account-deleted {
                td,
                th {
                    .el-dropdown {
                        .el-button {
                            background: red;
                            color: #ffffff !important;
                        }
                    }
                }
            }

            &.account-suspended {
                td,
                th {
                    .el-dropdown {
                        .el-button {
                            background: orange;
                            color: #ffffff !important;
                        }
                    }
                }
            }
        }

        .el-table__expanded-cell {
            background: #ffffff;
            box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.7) inset;
        }

        .cell {
            word-break: break-word;
        }
    }
}

.el-form-item__label {
    width: 100%;
    text-align: left;
}

.el-table .warning-row {
    background: oldlace;
}

.user {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0 10px 10px;
    border-bottom: 1px dotted #cccccc;

    .key {
        min-width: 300px;
        font-weight: 700;
    }
}
</style>
